import ThemeProvider from './ThemeProvider';

class ThemeService {
  constructor({ id, target = {} }) {
    this.id = target.id || id;
  }

  getInTheme(path = []) {
    return ThemeProvider.getInTheme(this.id, path);
  }

  getThemeVariants() {
    return ThemeProvider.getThemeVariants(this.id);
  }

  getThemeVariant(variantId, themeId) {
    return ThemeProvider.getThemeVariant(themeId, variantId);
  }

  setInTheme(theme, path = []) {
    return ThemeProvider.setInTheme(this.id, theme, path);
  }

  subscribeToTheme(path, callBackFn, coursewareId) {
    return ThemeProvider.subscribeToTheme(this.id, path, callBackFn, coursewareId);
  }

  static build(args) {
    return new ThemeService(args);
  }
}

export default ThemeService;
